import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import issLogo from '../assets/iss-logo.png';
import './AppTopBar.scss';

const AppTopBar: React.FC = () => {
  const { instance, accounts } = useMsal();
  const displayName = accounts[0]?.name || accounts[0]?.username || '';

  const signOut = () => {
    localStorage.removeItem('msalToken');
    void instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    });
  };

  return (
    <header className="app-topbar">
      <div className="app-topbar__pill">
        <Link to="/" className="app-topbar__brand" aria-label="PoC Platform home">
          <img src={issLogo} alt="" className="app-topbar__logo" />
          <span className="app-topbar__divider" aria-hidden />
          <span className="app-topbar__product">PoC Platform</span>
        </Link>

        <nav className="app-topbar__nav" aria-label="Primary">
          <NavLink to="/guidebook" className="app-topbar__link">
            PoC Guidelines
          </NavLink>
          <NavLink to="/my-pocs" className="app-topbar__link">
            My PoCs
          </NavLink>
          <NavLink to="/all-pocs" className="app-topbar__link">
            All PoCs
          </NavLink>
        </nav>

        <div className="app-topbar__end">
          {displayName ? (
            <span className="app-topbar__name">{displayName}</span>
          ) : null}
          <button type="button" className="app-topbar__signout" onClick={signOut}>
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
};

export default AppTopBar;
